import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BadgesAwardsService } from '../../../core/services/badges-awards/badges-awards.service';
import * as moment from 'moment-timezone';


@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css']
})
export class PaymentReceiptComponent implements OnInit {

  constructor(private router: Router, private service: BadgesAwardsService,
    private route: ActivatedRoute,
  ) { }

  paymentType: any;
  currentDate: Date;
  badgesN: any = [];
  badgeEco: any;
  badgeName: any;
  badgeIntro: any = [];
  amount: any;
  transId: any;
  currency: any;
  bid: any;
  statusBadges: any = [];
  ecoSystem: any = [];
  allBadges: any = [];
  names: any;
  id:any;

  ngOnInit(): void {
    const redirectFlag = localStorage.getItem('paymentRedirect');
    if (redirectFlag === 'true') {
      setTimeout(() => {
        localStorage.removeItem('paymentRedirect');
        localStorage.removeItem('stripePayment');
      }, 5000);
    } else {
      this.router.navigate(['/badges-awards']); 
    }
    this.bid = this.route.snapshot.paramMap.get('badgeId');
    const stripeFlag = localStorage.getItem('stripePayment');
    if(stripeFlag === 'true'){
      this.stripePayment();
    }
    else{
      this.payCurrency();
    }
  }

  userTimezoneNameSP(date: any) {
    var zone = moment.tz.guess();
    var newDate = new Date(date).toString()
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  stripePayment(){
    this.service.getStripeDetails(this.bid).subscribe((res:any)=>{
      console.log('stripe',res);
      this.badgesN = res.creaticsbadges;
      this.transId = res.chargeId;
      this.currentDate = res.paymentDate;
      this.paymentType = 'Card Payment';
      this.currency =this.badgesN.badgeamount;
      this.names = this.badgesN.badgename
      this.amount = this.badgesN.stripeAmount;
    })
  }

  payCurrency(){
      this.service.getPaymentDetails(this.bid).subscribe((res:any)=>{
        console.log('creatics ',res);
        this.amount = 'NA';
        this.currentDate = res.pDate;
        this.paymentType = 'Creatics Currency';
        this.currency = res.creaticsCurrency;
        this.names = res.names
      })
  }

    goBack(){
      this.router.navigate(['/badges-awards']);
    }
}
